import { Col, Row } from "react-bootstrap";
import leetlogo from "../../Assets/Abouts/Leetcode-img.png";
import ms from "../../Assets/Abouts/mslearn.png";
import infosys from "../../Assets/Abouts/infosys.png";
import ProjectCard from "./ProjectCards";
import linux from "../../Assets/Abouts/linux.png";
import net from "../../Assets/Abouts/networking-basics.png";
import salesforce from "../../Assets/Abouts/salesforce.jpeg";


function Certificates() {
  

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px", }}>
      <Col md={4} className="project-card">
        <ProjectCard 
          logo = {net}
          isBlog={false}
          title="Networking Basics"
          leetcodeLink="https://www.credly.com/badges/884207ea-5dc8-45ab-9633-7f143781f9c4"
        />
      </Col>
      

      <Col md={4} className="project-card">
        <ProjectCard
          isBlog={false}
          logo = {linux}
          title="Linux Unhatched"
          leetcodeLink="https://www.credly.com/earner/earned/share/f365de67-ae86-4f0b-84cd-56c0b504fb9f"
        />
        </Col>

         <Col md={4} className="project-card">
        <ProjectCard
          isBlog={false}
          logo = {ms}
          title="Microsoft Profile"
          leetcodeLink="https://learn.microsoft.com/en-us/users/arpitsharma6074/transcript/734jpf22pw1ylwz"
        />
        </Col>

         <Col md={4} className="project-card">
        <ProjectCard
          isBlog={false}
          logo = {infosys}
          title="Java Foundation"
          leetcodeLink="https://drive.google.com/file/d/1mnjiH4MZmICW6UZDXoxE1rRRLDZ9OUx0/view?usp=sharing"
        />
        </Col>

        <Col md={4} className="project-card">
        <ProjectCard
          isBlog={false}
          logo = {salesforce}
          title="Salesforce"
          description=""
          leetcodeLink="https://www.salesforce.com/trailblazer/ttuon0o9l9j7fupkwy"
        />
        </Col>
    </Row>
  );
}

export default Certificates;
